var $ = require("jquery");
var AOS = require("aos");
// var styleguide = require('./modules/style-guide.js');
// var accordions = require('./modules/accordions.js');
// var cards = require('./modules/cards.js');
var map = require("./modules/map.js");
var map2 = require("./modules/map2.js");
var menu = require("./modules/menu.js");
var highlightUnderlines = require("./modules/highlight-underlines.js");
var fancyapps = require("./modules/fancyapps.js");
var sliders = require("./modules/sliders.js");
var stats = require("./modules/stats.js");
// var svg = require('./modules/svg.js');

// Make sure that you init the styleguide first.
// styleguide.init();
// accordions.init();
// cards.init();
AOS.init();
map.init();
map2.init();
menu.init();
highlightUnderlines.init();
fancyapps.init();
sliders.init();
stats.init();
// svg.init();
